import { render, staticRenderFns } from "./publicorderlist.vue?vue&type=template&id=1d0ca61f&scoped=true&"
import script from "./publicorderlist.vue?vue&type=script&lang=js&"
export * from "./publicorderlist.vue?vue&type=script&lang=js&"
import style0 from "./publicorderlist.vue?vue&type=style&index=0&id=1d0ca61f&lang=less&scoped=true&"
import style1 from "./publicorderlist.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ca61f",
  null
  
)

export default component.exports